import { TextInput, type MantineSpacing } from '@mantine/core'
import { SearchNormal } from 'iconsax-reactjs'

import { colors } from 'src/theme/colors'

type HeroSearchInputProps = {
  value: string
  onChange: (value: string) => void
  placeholder: string
  maw?: number | string
  mt?: MantineSpacing
}

/**
 * The search field every navy GradientHero uses (News, Policies, People,
 * People Spotlight, Kudos) — same size/radius and the same "glass" input
 * styling (translucent white on the dark gradient), so a hero's search bar
 * looks identical everywhere instead of five near-duplicate style blocks.
 */
export const HeroSearchInput = ({
  value,
  onChange,
  placeholder,
  maw = 520,
  mt = 'sm'
}: HeroSearchInputProps) => (
  <TextInput
    size="md"
    radius="md"
    w="100%"
    maw={maw}
    mt={mt}
    value={value}
    onChange={(event) => onChange(event.currentTarget.value)}
    placeholder={placeholder}
    leftSection={<SearchNormal size={18} color={colors.neutralGray} />}
    styles={{
      input: {
        background: 'color-mix(in srgb, white 7%, transparent)',
        borderColor: 'color-mix(in srgb, white 16%, transparent)',
        color: colors.white
      }
    }}
  />
)
